import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import * as state from '@/components/Analysis/state';

export const useSideBySideVisibility = () => {
  const sideBySideModeEnabled = useAtomValue(state.sideBySideModeEnabled);
  const drawerRight = useAtomValue(state.drawerRight);

  const isDrawerOpen = useMemo(() => {
    const { equipment, ...rest } = drawerRight;
    return (
      sideBySideModeEnabled && equipment && !Object.values(rest).some((value) => Boolean(value))
    );
  }, [sideBySideModeEnabled, drawerRight]);

  return isDrawerOpen;
};
